import confetti from 'canvas-confetti';

// https://www.kirilv.com/canvas-confetti/

let $gameSettings = $('.js-game-settings');

const methods = {
    fireConfetti: function (style, time, colours, animation) {
        let duration = time !== undefined ? time : parseInt($gameSettings.attr('data-confetti-time'), 10);
        let animationEnd = Date.now() + (duration * 1000);

        colours = (colours !== undefined ? colours : $gameSettings.attr('data-confetti-colours')).split(',');

        style = style !== undefined ? style : $gameSettings.attr('data-confetti-style');

        (function frame() {
            switch (style) {
                case 'side':
                    confetti({
                        particleCount: colours.length,
                        angle: 60,
                        spread: 25,
                        origin: {x: 0},
                        colors: colours
                    });
                    confetti({
                        particleCount: colours.length,
                        angle: 120,
                        spread: 25,
                        origin: {x: 1},
                        colors: colours
                    });
                    break;
                case 'bottom':
                    confetti({
                        particleCount: colours.length,
                        angle: 60,
                        spread: 25,
                        origin: {y: 1},
                        colors: colours
                    });
                    confetti({
                        particleCount: colours.length,
                        angle: 120,
                        spread: 25,
                        origin: {y: 1},
                        colors: colours
                    });
                    break;
                case 'top':
                    confetti({
                        particleCount: colours.length,
                        angle: 270,
                        spread: 35,
                        origin: {y: 0, x: 0.2},
                        colors: colours
                    });
                    confetti({
                        particleCount: colours.length,
                        angle: 270,
                        spread: 35,
                        origin: {y: 0, x: 0.5},
                        colors: colours
                    });
                    confetti({
                        particleCount: colours.length,
                        angle: 270,
                        spread: 35,
                        origin: {y: 0, x: 0.8},
                        colors: colours
                    });
                    break;
            }

            if (Date.now() < animationEnd) {
                if (animation !== undefined) {
                    animation.frame = requestAnimationFrame(frame);
                } else {
                    requestAnimationFrame(frame);
                }
            }
        }());
    },

    resizeWheel: function () {
        let $wheel = $('.wheel'),
            $wheelContainer = $('.wheel-container'),
            maxWidth = $wheel.width(),
            maxHeight = $wheel.height() + 74,
            $elem = $('.game-container .panel-body'),
            width = $elem.width(),
            height = $elem.height(),
            scale;

        if (width >= maxWidth && height >= maxHeight) {
            $wheel.css({'-webkit-transform': ''});
            $wheelContainer.css({width: '', height: ''});
            return;
        }

        scale = Math.min(width / maxWidth, height / maxHeight);

        $wheel.css({'-webkit-transform': 'scale(' + scale + ')'});
        $wheelContainer.css({width: maxWidth * scale, height: maxHeight * scale});
    },

    scrollToForm: function () {
        let gameContent = $('.js-game-content');
        if (gameContent.length > 0) {
            $('html, body').animate({
                scrollTop: gameContent.offset().top
            }, 100);
        }
    },

    rand: function(min, max) {
        min = min || 0;
        max = max || Number.MAX_SAFE_INTEGER;

        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
};

export default methods;
